/**
 * This is not cryptographically secure, only use for basic unique client ids
 */
export const createNonSecureRandomId = () => Math.random().toString(36).substring(2);